import * as yup from 'yup';
import PropTypes from 'prop-types';

import {CONTENT_DEPARTMENT_ALL} from '../../contexts/Content/contentConstants';


// ------ shapes
export const SHAPE_SEARCH_BAR = {
    department: PropTypes.string,
    doAllowReset: PropTypes.bool,
    doShowDepartments: PropTypes.bool,
    text: PropTypes.string
};


// ------ search bar form schema
export const SCHEMA_SEARCH_TERM = yup.string()
    .nullable()
    .min(3)
    .max(50)
    .required();


export const SCHEMA_SEARCH_DEPARTMENT = yup.string()
    .default(CONTENT_DEPARTMENT_ALL)
    .required();


export const SCHEMA_SEARCH_BAR = yup.object()
    .shape({
        department: SCHEMA_SEARCH_DEPARTMENT,
        text: SCHEMA_SEARCH_TERM
    });
